export const SESSION_ID_HEADER = process.env.NEXT_PUBLIC_SESSION_ID_HEADER || 'lsvmfqcber'

// JWT auth (used on non-fsds tenant / custom domains where the session cookie can't reach the browser).
// Stored as first-party cookies on the FE host so SSR middleware and client JS can both read them.
export const ACCESS_TOKEN_COOKIE = 'at'
export const REFRESH_TOKEN_COOKIE = 'rt'

/** Internal header: FE hostname for SSR/middleware API routing (stripped before the request leaves axios). */
export const APP_HOST_HEADER = 'x-app-host'

export const FORM_REGISTER_URL = 'https://www.facebook.com/fullstackdatascience'
export const MLOPS_REFERENCE_URL =
  'https://docs.google.com/spreadsheets/d/16dQjvlGLSAfl9aoGheGGqDNZuktLPJ4q/edit?gid=2145456247#gid=2145456247'
export const MLOPS_REFERENCE_ENG_URL =
  'https://docs.google.com/spreadsheets/d/1grV22AreS4isTTxL-cnmnXGUjnu4gxBx/edit?gid=908181129#gid=908181129'
export const IGDS_REFERENCE_URL =
  'https://docs.google.com/spreadsheets/d/1wb8QfPssUVU0qTcf48ZrhX17RGAJcY-qZ9AiQVynkc0/edit?gid=2068386081#gid=2068386081'

export const CDA_REFERENCE_URL =
  'https://docs.google.com/spreadsheets/d/14OZnB6jl4PsECzUy4wIW2IlwAWr-ehpl_Jp0ppLYuww/edit?gid=2068386081#gid=2068386081'

export const LLMOps_REFERENCE_URL =
  'https://docs.google.com/spreadsheets/d/1G9T-zu08BZyjRpoBNaIzeVM5_P4Z0UgW1yQ-6j94tbY/edit?usp=sharing'

export const FEEDBACK_URL = 'https://www.facebook.com/fullstackdatascience/reviews'

export const DEBOUNCE_TIME_SUBMIT_ANSWER = 150

export const MAX_PROJECT_SUBMISSION = 3

/** Temporarily hide project submission UI on course detail. Set to true to re-enable. */
export const SHOW_PROJECT_SUBMISSION_ON_COURSE_DETAIL = false

export const MAX_FILE_SIZE = 5000000 // 5MB
export const MAX_CV_FILE_SIZE = 5 * 1024 * 1024 // 5MB
export const ALLOWED_CV_FILE_TYPES = ['.pdf', '.doc', '.docx']
export const coursesVideo = [
  { title: 'MLOps Fundamentals - Cloud Services', videoId: 'uNDfBPJ6FZ8' },
  {
    title: 'Data Engineering - Pipeline Orchestration',
    videoId: 'Pz49M6Tjxsk',
  },
  {
    title: 'Advanced MLOps - Serverless Architecture',
    videoId: '1LkDyhnX51M',
  },
  {
    title: 'LLM - Các Phương Pháp Tối Ưu Hệ Thống RAG Nâng Cao',
    videoId: 'KhAP_RwoWgo',
  },
  {
    title: 'ML - Hướng Dẫn Chi Tiết Phương Pháp EDA Cho Dữ Liệu Về Thu Nhập Với Python',
    videoId: 'Zv4VOQvW3cI',
  },
  {
    title: 'DA - Ứng dụng ChatGPT để tạo ra Dashboard SIÊU XỊN!',
    videoId: 'EAjmiPKveAs',
  },
]
